import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "How is this different from generic email marketing?",
    a: "NextVisit is built around the visit — the moment your customer felt best about your work. Follow-ups are timed to that moment, personal to that customer, and tied to the exact service they had. It's the opposite of a mass blast.",
  },
  {
    q: "Will messages sound like a robot?",
    a: "No. You pick the voice, tone, and templates once — warm, quiet, playful, professional — and NextVisit weaves in the specifics of each visit. Your regulars won't notice a difference.",
  },
  {
    q: "What booking systems do you support?",
    a: "Right now, Square Appointments syncs automatically — customers and bookings flow in via API + webhooks. Vagaro, Fresha, Mindbody, Acuity, Calendly, and Google Calendar are on our roadmap. Using one of those today? You can add customers and appointments manually in the meantime, and we'll email you the moment your booking tool is live.",
  },
  {
    q: "How long does setup take?",
    a: "Square users: about three minutes to connect. Everyone else: about five minutes to add your first customers manually or import from CSV. Either way, most businesses see their first automated thank-you go out the same day.",
  },
  {
    q: "Can I approve messages before they send?",
    a: "Always. Choose auto-mode when you're behind the chair, or approve every send from the app. You're in charge.",
  },
  {
    q: "Do I need a credit card to start the trial?",
    a: "Nope. 14 days free, no card required. Add one only when you're ready.",
  },
  {
    q: "What happens after the trial?",
    a: "Pick the plan that fits. If you don't, everything gracefully pauses — your data waits for you, no lockouts, no drama.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-24 sm:py-32">
      <div className="max-w-4xl mx-auto px-6 sm:px-10 lg:px-16">
        <div className="mb-14">
          <div className="overline mb-4">Frequently asked</div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#183D36]">
            The quiet answers.
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-3" data-testid="faq-accordion">
          {FAQS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="rounded-2xl border border-[#E5E0D8] bg-white px-6 data-[state=open]:bg-[#FAF7F0]"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-heading text-lg text-[#183D36] text-left hover:no-underline py-5">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#4A4A4A] text-base leading-relaxed pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
